import { render } from "./BannerCookie.component.vue?vue&type=template&id=8810d768"
import script from "./BannerCookie.component.vue?vue&type=script&lang=js"
export * from "./BannerCookie.component.vue?vue&type=script&lang=js"

import "./BannerCookie.component.vue?vue&type=style&index=0&id=8810d768&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__